import React from 'react'
import ReactBlockly from 'react-blockly';

export function Editor() {
    return (
        <ReactBlockly />
    )
}